import request from "@/util/request";

export function Login(data) {
  return request({
    url: "/pc/Login/Login",
    method: "post",
    data,
  });
}
export function Register(data) {
  return request({
    url: "/pc/Login/Register",
    method: "post",
    data,
  });
}
export function ForgotPassword(data) {
  return request({
    url: "/pc/Login/ForgotPassword",
    method: "post",
    data,
  });
}
export function getInfo(params) {
  return request({
    url: "/admin/Home/GetAdminInfo",
    method: "get",
    params,
  });
}
